export default {

    //General phrases
    tollWord: 'Оплата за проезд моста фетешть | Оплата за проезд моста фетешть | Peaje',
    vignetteWord: 'Ровиньетка | Ровиньетки',

    site_tpf: 'taxa-pod-fetesti.ro',
    site_erv: 'e-rovinieta.ro',

    currency: 'леи',
    category: 'категория',
    select_type_of_vehicle: 'Выберите тип автомобиля',
    select_the_period: 'Select the period',
    or_pay_for: 'Или заплатите за',
    your_vehicles_link: 'ваши автомобили',
    or_go_to_your_account_and_buy: 'Или войдите в ваш аккаунт и купите напрямую для ваших автомобилей',
    see_cart: 'Посмотрите стоимость',
    or: 'или',
    and: 'и',
    back: 'назад',
    total: 'Всего',
    pf: 'Физическое лицо',
    pj: 'Юридическое лицо',
    yes: 'Да',
    no: 'Нет',
    about: 'О',
    us: 'нас',

    vignette: 'ровиньетка | ровиньетки',
    passing: 'переезд | переезды',

    toll_buy: 'Заплатите за проезд через мост',
    vignette_buy: 'Заплатите за ровиньетку',

    //Order
    billing_add_new_profile: 'Добавить новый профиль для фактурирования',

    cart_empty: 'Корзина пуста',
    cart_available_from: 'действительно начиная с',
    cart_add_more: 'Продолжайте добавлять в корзину другие',
    cart_continue_with_buying: 'Купите еще',
    cart_validation_errors: 'Изделия, устраненные из заказа из-за ошибок валидации',

    order_container_place_order_title: 'Сделать заказ',
    order_container_my_cart: 'Моя корзина',
    order_container_billing_info: 'Данные фактурирования',
    order_container_payment: 'Оплата',

    payment_method_insuficient_credit: 'недостаточно средств',
    payment_method_instant_credit: 'Мгновенный кредит',
    payment_method_instant_credit_description: 'Мгновенный кредит',
    payment_method_credit_card: 'Онлайн с банковской карточкой',
    payment_method_credit_card_description: 'Оплата будет обработана через PayU.ro',
    payment_method_iTransfer_description: 'Платежное поручение с немедленным подтверждением',
    payment_method_payment_order: 'Платежное поручение',
    payment_method_payment_order_description: 'Получите на электронный адрес платформу, соответствующую покупке, продолжая платежные поручения. Заказ будет выдан в момент получения оплаты',
    payment_method_credit_erv: 'Кредит е-ровиньетка',
    payment_method_credit_tpf: 'Кредит на оплату проезда моста фетешть',
    payment_method_terms: 'Подтверждаю, что вышеуказанные данные являются правильными и я прочитал и согласен со сроками и условиями',

    thank_you_placed_order_title: 'Заказ размещен',
    thank_you_successful_order: 'Заказ размещен успешно!',
    thank_you_see_info_order: 'Посмотрит ее статус в моих заказах',
    thank_you_my_orders: 'Мои заказы',

    //Account
    continue_with: 'Continue with',
    account_activate_header: 'Активировать аккаунт',
    account_activate_message: '',

    account_container_my_account: 'Мой аккаунт',
    account_container_vehicles: 'Автомобили',
    account_container_orders: 'Заказы',
    account_container_profiles: 'Профили фактурирования',
    account_container_info: 'Данные аккаунта',

    account_data_title: 'Данные аккаунта',

    add_car_title: 'Добавить автомобиль',

    add_profile_title: 'Добавление профиля',
    add_profile_pj_extracted: 'Данные юридического лица, которые были извлечены автоматически',

    edit_car_no_vehicles: 'Ни один автомобиль не был найден!',
    edit_car_delete_vehicle_title: 'Удалить автомобиль',
    edit_car_delete_vehicle: 'Вы уверены, что хотите удалить этот автомобиль?',

    my_orders_passings: 'один проезд | {count} проездов',

    profiles_main: 'Главный',
    profiles_secondary: 'Второстепенный',
    profiles_unverified_data: 'Непроверенные данные',
    profiles_no_profile: 'Нет ни одного профиля',
    profiles_delete_profile: 'Удалить профиль',
    profiles_are_you_sure: 'Вы уверены, что хотите удалить профиль?',

    //Authentication
    login_auth: 'Аутентификация',
    login_login_into_your_account: 'Войдите в ваш аккаунт',

    login_component_login_by: 'Войдите с',
    login_component_no_account: 'У вас нет аккаунта?',
    login_component_forgot_password: 'Забыли пароль?',

    new_account_title: 'Новый аккаунт',
    new_account_details: 'Подробности аккаунта',
    new_account_ive_read: 'Прочитал и согласен со',
    new_account_tc: 'сроками и условиями',
    new_account_site: 'сайта',
    new_account_pc: 'Политика конфиденциальности',
    mandatory: 'Обязательно',
    new_account_must_accept_tc: 'Вы должны принять сроки и условия',
    new_account_must_accept_pc: 'Вы должны принять политику конфиденциальности',

    contact_title: 'Контакт',

    header_how_does_it_work: 'Как это работает?',

    how_it_works_p1: 'В путь за 3 минуты!',
    how_it_works_p2: 'Уполномоченный дистрибьютор CNAIR',
    how_it_works_p3: 'Заказывайте он-лайн с taxa-pod-fetesti.ro',

    toll_category_error_loading_car: 'Проблема при загрузке автомобиля',
    toll_category_error_loading_country: 'Проблема при загрузке стран',

    vignette_category_error_fromdate: 'Выберите дату начала действия ровиньетки',

    //Buttons
    btn_save: 'Сохранить',
    btn_save_changes: 'Сохранить изменения',
    btn_add_car: 'Добавить автомобиль',
    btn_delete_car: 'Удалить автомобиль',
    btn_next_step: 'Следующий шаг',
    btn_finish: 'Закончить',
    btn_grab_data_company: 'Получить данные<br/> Торговый реестр',
    btn_add_profile: 'Добавить новый профиль',
    btn_i_understand: 'Понял',
    btn_login: 'Подключиться',
    btn_register: 'Зарегистрироваться',
    btn_create_account: 'Создать аккаунт',
    btn_add_to_cart: 'Добавить в корзину',
    btn_edit_to_cart: 'Изменить продукт',
    btn_reset_password: 'Сброс пароля',
    btn_bill: 'Factureaza',
    btn_choose_payment_method: 'Choose payment method',


    //Labels
    label_email: 'Электронный адрес',
    label_password: 'Пароль',
    label_confirm_password: 'Подтвердить пароль',
    label_license_plate: 'Регистрационные номера',
    label_chasis_number: 'Серия шасси',
    label_registration_country: 'Страна регистрации',
    label_motif: 'Причина низшей категории',
    label_choose_category: 'Выберите категорию для',
    label_billing_type: 'Фактурировать на',
    label_last_name: 'Имя',
    label_first_name: 'Фамилия',
    label_country: 'Страна',
    label_county: 'Уезд',
    label_city: 'Город',
    label_address: 'Адрес',
    label_cui: 'Единый идентификационный код',
    label_reg_com: 'Торговый реестр',
    label_locality: 'Населенный пункт',
    label_company_name: 'Наименование компании',
    label_for_car: 'Для автомобиля',
    label_available_from: 'Действительно начиная с',

    //terms
    terms: 'Условия и положения',
    partners: 'партнер',

    delete_product_title: 'Delete product',
    delete_product: 'Are you sure you want to delete this product?',


    //New terms
    btn_edit: 'Изменить',
    btn_edit_password: 'Изменить пароль',
    btn_edit_phone: 'Изменить телефон',
    btn_delete_account: 'Удалить аккаунт',
    btn_import_csv: 'Импортировать csv',
    btn_export_csv: 'Экспортировать csv',

    //account
    data_saved_succesfully: 'Данные успешно сохранены',
    invalid_plate_number_message: 'Номер указан не в правильном формате',
    invalid: 'Недействительно',
    countries_loading: 'Проблема при загрузке стран',
    tpf_categories_loading: 'Проблема при загрузке категорий оплаты проезда моста фетешть',
    erv_categories_loading: 'Проблема при загрузке категорий ровиньетки',
    csv_header: 'Номер, Шасси, Категория ровиньетки, Категория оплаты проезда моста фетешть, Страна',
    order_header_name: 'Фамилия',
    date: 'Дата',
    order_header_payment_type: 'Тип оплаты',
    order_header_status: 'Статус',
    no_placed_order: 'Нет ни одного размещенного заказа.',
    i_want: 'Хочу',
    no_order: 'Заказ не был найден.',

    product_status: 'Статус',
    product_payment_method: 'Метод оплаты',
    product_bill_data: 'Данные фактурирования',
    product_valability: 'Действительность',

    download_bill: 'Скачать счёт',
    vignette_series: 'Серия ровиньетки',
    toll_series: 'Серия платежа',

    //authentication
    login_account: 'Войдите в аккаунт',
    already_have_account: 'У вас уже есть аккаунт?',
    password: 'Пароль',
    password_confirm: 'Повторить пароль',
    return_to_login_1: 'Вернуться к странице',
    return_to_login_2: 'Логин',

    // order
    choose_profile: 'Выберите профиль',
    order_step4: 'Шаг 4: Фактурирование',
    login_to_your_account: 'Войдите в Ваш аккаунт',
    login_to_your_account_2: 'и выберите уже сохраненные данные фактурирования.',
    order_without_account: 'Вы можете разместить заказ без аккаунта, заполнив нижеуказанные данные',
    fill_all_fields: 'Заполните все обязательные к заполнению поля',
    order_address_info: 'По этому адресу Вы получите счет и ровиньетку',
    invalid_profile_msg: 'Этот профиль не действителен',
    delete_profile_msg: 'Удалить профиль',
    delete_profile_confirm: 'Вы уверены, что хотите удалить профиль?',
    invalid_email: 'Электронный адрес недействителен',
    invalid_tel: 'Телефон недействителен',
    mandatory_city: 'Город является обязательным',
    mandatory_first_name: 'Имя является обязательным',
    mandatory_last_name: 'Фамилия является обязательной',
    mandatory_country: 'Область является обязательной',
    mandatory_fiscal_code: 'Единый идентификационный код является обязательным',
    mandatory_j_code: 'Торговый реест является обязательным',
    mandatory_company: 'Компания является обязательной',
    mandatory_address: 'Адрес является обязательным',
    my_shopping_cart: 'Моя корзина',
    order_step3: 'Шаг 3: Краткий обзор',
    buy_vignette_or_bridge_fee: 'Можете купить ровиньетку или оплату проезда моста Фетешть',
    order_step5: 'Шаг 5: Оплата',
    warning: 'ВНИМАНИЕ!',
    warning_txt_1: 'Для оплаты ровиньеток платежным поручением, заказ будет утвержден после получения денег на банковский счет UNTRR.',
    warning_txt_2: 'Ровиньетку, оплаченные платежным поручением, выдаются с понедельника до пятницы, в интервале времени с 08:00 до 16:30.',
    warning_txt_3: 'Не отправляйтесь в путь пока не получите подтверждение о выдаче ровиньетки.',
    warning_txt_4: 'UNTRR не несет ответственности за несоблюдение вышеуказанных условий!',
    choose_card: 'Выберите одну из ваших сохраненных карточек',
    new_card: 'Новая карточка',
    add_card_for_next_transactions: 'Добавить карточку в мой аккаунт для будущих покупок',

    free: 'Бесплатно',
    btn_logout: 'Выйти',
    info: 'Инфо',

    frequent_questions_heading: 'Часто задаваемые вопросы и ответы',
    see_all_frequent_questions: 'Посмотрите все вопросы и ответы',

    step: 'Step {n}',
    choose_passings_number: 'Выберите количество переходов',
    vehicles: 'Легковые автомобили',

    juridical_person: 'Юридическое лицо',
    individual_person: 'Физическое лицо',
    auto_query_company_data: 'Получаем автоматически данные компании',
    verified_company_data: 'Данные компании проверены!',
    unverified_company_data: 'Данные компании не проверены',
    check_vignette_valability: 'Проверить действительность ровиньетки',
    resources: 'Ресурсы',
    i_want_vignette: 'Хочу ровиньетку',
    i_want_toll: 'Хочу оплату за мост Фетешть',
    vehicle_type: 'Тип автомобиля',
    period: 'Период',
    summary: 'Краткий обзор',
    billing: 'Фактурирование',
    payment: 'Оплата',
    you_have_multiple_usernames: 'У вас <b>{count}</b> аккаунтов, присоединенных к этому электронному адресу.',
    choose_login_account: 'Выберите аккаунт с которым хотите подключиться',

    //benefits page
    bp_company_advantages: 'Преимущества для компаний',
    bp_one_account_multiple_advantages: 'Один аккаунт, много преимуществ',
    bp_contact_us_for_personalized_solution: 'Свяжитесь с нами для индивидуализированного решения',
    bp_online_emission: 'Выдача онлайн 24/7',
    bp_online_assistance: 'У вас есть онлайновая помощь и может купить ровиньетку или оплату проезда моста Фетешть 24/7',
    bp_import_your_cars: 'Импортировать весь автомобильный парк',
    bp_import_you_cars_through_excel: 'Импортируйте к нам весь автомобильный парк компании, на основании файла excel.',
    bp_multiple_profiles: 'Больше профилей',
    bp_multiple_profiles_for_same_email: 'У Вас есть возможность создать много профилей для всех пользователей компании, с тем же электронным адресом.',
    bp_vignettes_status: 'Статус ровиньеток',
    bp_verify_vignette_status: 'На сайте можете всегда проверить статус выданных ровиньеток.',
    bp_orders_history: 'История заказов',
    bp_orders_history_description: 'В рамках аккаунта можете найти все размещенные заказы и счета.',
    bp_multiple_orders: 'Многочисленные заказы',
    bp_multiple_orders_description: 'Можете добавить несколько ровиньеток в корзину и разместить многочисленные заказы.',
    bp_email_sms_confirmation: 'Подтверждение по электронной почте и СМСкой',
    bp_email_sms_confirmation_description: 'Получите подтверждение о выдачи ровиньетки по электронной почте и СМСкой.',
    bp_expiry_alerts: 'Оповещения об истечении срока',
    bp_expiry_alerts_description: 'Для ровиньеток сроком на и больше 30 дней, оповещаем Вас по электронной почте до истечения их срока.',
    bp_need_help: 'Вам нужна помощь?',
    bp_call_operators: 'Обратитесь к одному из наших операторов для помощи для выдачи ровиньеток. Служба доступна с понедельника до пятницы (за исключением официальных праздников), с 08 до 17.',
    bp_offices: 'Список представительств',
    bp_have_cars: 'Владеете парком автомобилей?',
    bp_contact_us_for_personalized_solution_for_your_bussiness: 'Свяжитесь с нами, чтобы получить индивидуализированное решение для вашего бизнеса.',
    bp_contact_us_now: 'Свяжитесь с нами сейчас',


    //contact
    contact_viggnete_emission: 'Выдача ровиньеток',
    contact_agencies: 'Агентства',
    contact_see_all_agencies: 'Посмотрите все областные агентства',
    contact_see_all_agencies_continuation: 'откуда можете получить ровиньетку.',

    //distribution
    distribution_header: 'СПИСОК РАБОЧИХ ТОЧЕК, ПРИНАДЛЕЖАЩИХ UNTRR, УПОЛНОМОЧЕННЫХ ПОЛУЧАТЬ ОПЛАТУ ЗА ИСПОЛЬЗОВАНИЕ СЕТИ НАЦИОНАЛЬНЫХ ДОРОГ РУМЫНИИ (РОВИНЬЕТКА)',
    distribution_nr_crt: 'Пор. №',
    distribution_work_point: 'Рабочая точка',
    distribution_terminals_and_portals: 'ТЕРМИНАЛЫ И ВЕБ-ПОРТАЛЫ',
    distribution_name: 'Название',
    distribution_terminals: 'Терминалы ZEBRAPAY',
    distribution_location_terminal_details: 'Подробности о размещении терминалов ZEBRAPAY',
    distribution_untrr_portal: 'ПОРТАЛ UNTRR (Национального союза автоперевозчиков Румынии)',


    //footer
    footer_copyright: 'Все права зарезервированы 2010 - 2020 @ Национальный союз автоперевозчиков Румынии (UNTRR).',


    //homepage
    homepage_authorized_distributor: 'Уполномоченный дистрибьютор C.N.A.I.R',
    homepage_buy_tpf_erv: 'Купить ровиньетку или оплату за проезд моста Фетешть',
    homepage_ready_for_road: 'Готов к дороге немедленно',
    homepage_order: 'Заказать',
    homepage_payment: 'Оплатить',
    homepage_drive: 'Разъезжай',
    homepage_your_advantages: 'Ваши преимущества',
    homepage_vignette_availability: 'Проверяете действительность ровиньетки',
    homepage_vignette_availability_description_1: 'Не знаете если ровиньетка действительна? Избегайте штрафа.',
    homepage_vignette_availability_description_2: 'Проверьте действительность тут',
    homepage_save_data: 'Сохраните данные',
    homepage_save_data_description: 'Делаете себе аккаунт, сохраняйте данные машины, и покупаете ровиньетку и осуществляете оплату за проезд моста Фетешть в одном месте.',
    homepage_sms_email_delivery: 'Доставка по электронному адресу и СМСкой',
    homepage_sms_email_delivery_description: 'Доставка по электронному адресу и СМСкой',
    homepage_card_or_op: 'Оплачивайте карточкой или платежным поручением',
    homepage_card_or_op_description: 'Быстрое и надежное приобретение банковской карточкой или платежным поручением.',
    homepage_notify_expiry: 'Уведомление об истечении срока',
    homepage_notify_expiry_description: 'Для ровиньеток с периодом больше 30 дней, уведомляем вас до истечения срока.',
    homepage_professional_services: 'Профессиональные услуги',
    homepage_professional_services_description: 'От профессионалов в сфере перевозок всем пользователям дорожной сети Румынии.',
    homepage_online_assistance: 'В добавок, вы получаете онлайновую помощь и можете воспользоваться индивидуализированным решением для потребностей Вашей компании.',
    homepage_discover_all_benefits: 'Откройте всю выгоду',
    homepage_distribution_points: 'Пункты дистрибуции',
    homepage_authorized_distributor_2: 'UNTRR является уполномоченным дистрибьютором C.N.A.I.R. для выдачи электронных ровиньеток с присутствием в онлайновой среде и с территориальными пунктами.',
    homepage_distribution_points_description: 'Посмотрите список пунктов дистрибуции',
    homepage_frequent_questions: 'Часто задаваемые вопросы и ответы',
    homepage_frequent_questions_description: 'Посмотрите все вопросы и ответы',

    //info
    info_download_file: 'Скачать файл',

    //reset
    reset_cart: 'Корзина была сброшена.',

    sms_notice: '<strong>Платная услуга уведомлений по СМС</strong><br/><br/> Услуга уведомлений короткими сообщениями (СМС) позволяет уведомлять клиентов www.taxa-pod-fetesti.ro для подтверждения выдачи мост платный, соответственно, уведомлять клиентов о истечении срока действия мост платный. Услуга не является обязательной, предоставляется по выбору клиента и действительна только для заказов, оплаченных онлайн через платежную систему (PayU).<br/><br/>За правильность данных и информации из СМС о выдаче и/или истечении срока действия мост платный, регистрационного номера, серии шасси и номера мобильного телефона, введенных на платформе www.taxa-pod-fetesti.ro , ответственность несёт пользователь.<br/><br/> СМС-уведомление осуществляется через NETOPIA Payments.<br/><br/> Система СМС-уведомлений отправляет уведомления клиентам, выбравшим эту услугу.<br/><br/> На получение СМС с подтверждением/истечением срока действия может влиять работа и покрытие телекоммуникационных сетей, работа используемых устройств и т. д.<br/><br/>    Для уведомлений, пожалуйста, используйте контактную страницу веб-сайта www.taxa-pod-fetesti.ro.<br/><br/>'
};
